import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ReportGenerationApiResponse } from '../../../shared/model/api-response.model';

@Injectable({
  providedIn: 'root',
})
export class PerformanceService {
  http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  getMyHistory() {
    return this.http.get('/Performance/GetMyHistory').toPromise();
  }

  getCurrentStatus() {
    return this.http.get('/Performance/GetCurrentStatus').toPromise();
  }

  getPRCo() {
    return this.http.get('/Performance/GetPRCo').toPromise();
  }

  getManagerGrid(pRCoForFilter?: number, hidePreviousReview?: boolean) {
    return this.http
      .get('/Performance/GetManagerGrid?pRCoForFilter=' + pRCoForFilter + '&hidePreviousReview=' + hidePreviousReview)
      .toPromise();
  }

  createPerformanceReview(performanceInstanceID: string) {
    return this.http
      .post('/Performance/CreatePerformanceReview', {
        performanceInstanceID: performanceInstanceID,
      })
      .toPromise();
  }

  confirmInstance(performanceInstanceID?: number) {
    return this.http
      .post('/Performance/ConfirmInstance', {
        performanceInstanceID: performanceInstanceID,
      })
      .toPromise();
  }

  getChecklistReviewers(checklistInstanceID: number) {
    return this.http.get('/Checklist/GetChecklistReviewers?checklistInstanceID=' + checklistInstanceID).toPromise();
  }

  initializeChecklistReviewers(checklistInstanceID: number) {
    return this.http
      .post('/Checklist/InitializeChecklistReviewers', {
        checklistInstanceID: checklistInstanceID,
      })
      .toPromise();
  }

  deleteChecklistReviewers(checklistRevID: number) {
    return this.http
      .post('/Checklist/DeleteChecklistReviewers', {
        checklistRevID: checklistRevID,
      })
      .toPromise();
  }

  sendChecklists(
    checklistInstanceIDs: number,
    filenames: string[],
    fromEmail: string,
    toEmail: string[],
    subject: string,
    message: string,
    newFilenames: string[],
    newFiles: any[],
    templateID: any[],
    mailFrom: string,
    queueType: string,
    notificationMode: string,
    sMSTo: string
  ) {
    return this.http
      .post('/Checklist/SendChecklists', {
        checklistInstanceIDs: checklistInstanceIDs,
        filenames: filenames,
        fromEmail: fromEmail,
        toEmail: toEmail,
        subject: subject,
        message: message,
        newFilenames: newFilenames,
        newFiles: newFiles,
        templateID: templateID,
        mailFrom: mailFrom,
        queueType: queueType,
        notificationMode: notificationMode,
        sMSTo: sMSTo,
      })
      .toPromise();
  }

  sendChecklistSign(signatureDataStr: string, checklistInstanceID: number, typeSign: boolean, latitude: number, longitude: number) {
    return this.http
      .post('/Checklist/SendChecklistSign', {
        signatureDataStr: signatureDataStr,
        checklistInstanceID: checklistInstanceID,
        typeSign: typeSign,
        latitude: latitude,
        longitude: longitude,
      })
      .toPromise();
  }

  getPerformanceInfo(checklistInstanceID: number) {
    var url = '/Performance/GetPerformanceInfo?checklistInstanceID=' + checklistInstanceID;
    return this.http.get(url).toPromise();
  }

  getTemplateInfo(checklistTemplateID: number) {
    var url = '/Checklist/GetTemplateInfo?checklistTemplateID=' + checklistTemplateID;
    return this.http.get(url).toPromise();
  }

  getChecklistInstanceDetails(checklistInstanceID: number) {
    var url = '/Checklist/GetChecklistInstanceDetails?checklistInstanceID=' + checklistInstanceID;
    return this.http.get(url).toPromise();
  }

  getLookupMaxChoice() {
    var url = '/Checklist/GetLookupMaxChoice';
    return this.http.get(url).toPromise();
  }

  completeReview(checklistInstanceID: number, templateID: number, fileName: string) {
    return this.http
      .post('/Performance/CompleteReview', {
        checklistInstanceID: checklistInstanceID,
        templateID: templateID,
        fileName: fileName,
      })
      .toPromise();
  }

  getAnalytics(pRCoForFilter?: number, templateFilter?: string, fromDateStr?: string, toDateStr?: string) {
    var url =
      '/Performance/GetAnalytics?pRCoForFilter=' +
      pRCoForFilter +
      '&templateFilter=' +
      templateFilter +
      '&fromDateStr=' +
      fromDateStr +
      '&toDateStr=' +
      toDateStr;
    return this.http.get(url).toPromise();
  }

  getAdminGrid(
    pRCoForFilter?: number,
    createdDateStartStr?: string,
    createdDateEndStr?: string,
    statusFilter?: string,
    templateFilter?: string
  ) {
    var url =
      '/Performance/GetAdminGrid?pRCoForFilter=' +
      pRCoForFilter +
      '&createdDateStartStr=' +
      createdDateStartStr +
      '&createdDateEndStr=' +
      createdDateEndStr +
      '&statusFilter=' +
      statusFilter +
      '&templateFilter=' +
      templateFilter;
    return this.http.get(url).toPromise();
  }

  editPerformanceInstance(performanceInstanceID: string, dateDueStr: string) {
    return this.http
      .post('/Performance/EditPerformanceInstance', {
        performanceInstanceID: performanceInstanceID,
        dateDueStr: dateDueStr,
      })
      .toPromise();
  }

  purgePerformanceInstance(performanceInstanceID?: number) {
    return this.http
      .post('/Performance/PurgePerformanceInstance', {
        performanceInstanceID: performanceInstanceID,
      })
      .toPromise();
  }

  unsubmitReview(performanceInstanceID?: number, performanceReviewerID?: number) {
    return this.http
      .post('/Performance/UnsubmitReview', {
        performanceInstanceID: performanceInstanceID,
        performanceReviewerID: performanceReviewerID,
      })
      .toPromise();
  }

  getChecklistTemplates(checklistTemplateCatgID?: number) {
    //move to checkListService
    var url = '/Checklist/GetChecklistTemplates?checklistTemplateCatgID=' + checklistTemplateCatgID;
    return this.http.get(url).toPromise();
  }

  getAttendees() {
    return this.http.get('/Admin/GetAttendees').toPromise();
  }

  getReviewersByInstance(performanceInstanceID: any) {
    var url = '/Performance/GetReviewersByInstance?performanceInstanceID=' + performanceInstanceID;
    return this.http.get(url).toPromise();
  }

  reviewerAdd(performanceInstanceID: any, reviewerUserKeyID: number) {
    return this.http
      .post('/Performance/ReviewerAdd', {
        performanceInstanceID: performanceInstanceID,
        reviewerUserKeyID: reviewerUserKeyID,
      })
      .toPromise();
  }

  reviewerDelete(performanceInstanceID: any, performanceReviewerID: number) {
    return this.http
      .post('/Performance/ReviewerDelete', {
        performanceInstanceID: performanceInstanceID,
        performanceReviewerID: performanceReviewerID,
      })
      .toPromise();
  }

  sendReminderEmail(performanceInstanceIDString: string, isScheduled: boolean, sendEmail: boolean) {
    return this.http
      .post('/Performance/SendReminderEmail', {
        performanceInstanceIDString: performanceInstanceIDString,
        isScheduled: isScheduled,
        sendEmail: sendEmail,
      })
      .toPromise();
  }

  getTemplateCategories(checklistTemplateCatgID: number) {
    var url = '/Checklist/GetTemplateCategories?checklistTemplateCatgID=' + checklistTemplateCatgID;
    return this.http.get(url).toPromise();
  }

  getEmplByChecklistTemplateID(checklistTemplateID: number) {
    var url = '/Performance/GetEmplByChecklistTemplateID?checklistTemplateID=' + checklistTemplateID;
    return this.http.get(url).toPromise();
  }

  initializePerformanceInstance(requestObj: any) {
    return this.http
      .post('/Performance/InitializePerformanceInstance', {
        userKeyIDString: requestObj.userKeyIDString,
        dateDueStr: requestObj.dateDueStr,
        employeeChecklistTemplateID: requestObj.employeeChecklistTemplateID,
        managerChecklistTemplateID: requestObj.managerChecklistTemplateID,
        disableSelfReview: requestObj.disableSelfReview,
      })
      .toPromise();
  }

  async updateMgrReviewer(params: HttpParams) {
    return await this.http.post('/Performance/UpdateMgrReviewer', params).toPromise();
  }

  downloadPerformanceTabular(
    pPRCoForFilter: number,
    createdDateStart: string,
    createdDateEnd: string,
    statusFilter: string,
    templateFilter: number,
    fileName: string,
    exportFileType: string
  ): Observable<ReportGenerationApiResponse> {
    const params = new HttpParams()
      .set('pPRCoForFilter', pPRCoForFilter)
      .set('createdDateStart', createdDateStart)
      .set('createdDateEnd', createdDateEnd)
      .set('statusFilter', statusFilter)
      .set('templateFilter', templateFilter)
      .set('fileName', fileName)
      .set('exportFileType', exportFileType);

    return this.http.get<ReportGenerationApiResponse>('/Performance/DownloadPerformanceTabular', { params: params });
  }
}
